// Shared libraries array for every useJsApiLoader/useLoadScript call in the
// app. @react-google-maps/api backs onto a single script-loading singleton —
// calling it from multiple components with different `libraries` arrays
// triggers "Loader must not be called again with different options" and can
// silently drop libraries a later component needed. Keeping one exported
// array (same reference everywhere) avoids that entirely.
export const GOOGLE_MAPS_LIBRARIES = ['places'];
